import { tdsFetch, jsonToQuery, thirdPartyFetch,tdPDF } from '@/utils/fetch';
// 使用系统前缀
const sysPrefix = '/innovation/innovation';
export const innovationAdd = (data) => {
  return tdsFetch( `${sysPrefix}/project/add`, { method: 'POST', body: data, joinPrefix: false })
}

// 相似专利查询
export const patentSemanticsSearch = (data) => {
  return tdsFetch( `${sysPrefix}/patent/semanticsSearch`, { method: 'POST', body: data, joinPrefix: false })
}
//相似专利列表
export const incopatSearch = (data) => {
  return tdsFetch( `${sysPrefix}/patent/incopatSearch`, { method: 'POST', body: data, joinPrefix: false })
}
//相似专利详情
export const patentPdfSearch = (data) => {
  return tdPDF( `${sysPrefix}/patent/pdfStream`, {
    method: 'POST',
    body: JSON.stringify(data),
    joinPrefix: false,
  })
}
//相似专利缩略图
export const patentPdfDrawing = (data) => {
  return tdsFetch( `${sysPrefix}/patent/pdfDrawing`, {
    method: 'POST',
    body: JSON.stringify(data),
    joinPrefix: false,
  })
}

// 项目分页查询
export const projectPage = (data) => {
  // 移除手动添加的问号，jsonToQuery函数会自动添加
  return tdsFetch( `${sysPrefix}/project/page${jsonToQuery(data)}`, { method: 'GET', joinPrefix: false })
}
// 项目详情查询
export const projectDetail = (id) => {
  return tdsFetch( `${sysPrefix}/project/${id}`, { method: 'GET', joinPrefix: false })
}
//项目编辑接口 - 上传技术过程和技术路径数据
export const projectEdit = (id, data, status) => {
  return tdsFetch( `${sysPrefix}/project/${id}`, { method: 'PUT', body: {projectContent: data, projectStatus: status}, joinPrefix: false })
}
// 用户详情查询
export const userDetail = () => {
  return tdsFetch( `${sysPrefix}/sys-user/userId`, {
    method: 'GET',
    joinPrefix: false,
    ignoreAuthFailure: true
  })
}
// 更新当前用户资料
export const updateUserProfile = (data) => {
  return tdsFetch( `${sysPrefix}/sys-user/profile`, { method: 'PUT', body: data, joinPrefix: false })
}
// 用户列表查询
export const userList = () => {
  return tdsFetch( `${sysPrefix}/sys-user/list`, { method: 'GET', joinPrefix: false })
}
